import { Directive, Input, OnDestroy, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { CustomPermissionAuthService } from '../services/custom-permission-auth.service';

@Directive({
  selector: '[appHasNotCustomPermission]'
})
export class HasNotCustomPermissionDirective implements OnDestroy {
  private permissionSubscription?: Subscription;
  private currentPermissions: string[] = [];

  @Input() set appHasNotCustomPermission(permission: string | string[]) {
    this.currentPermissions = Array.isArray(permission) ? permission : [permission];
    this.updateView();
  }

  @Input() appHasNotCustomPermissionMode: 'all' | 'any' = 'any';

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private permissionService: CustomPermissionAuthService
  ) { 
    this.permissionSubscription = this.permissionService.permissionsChanged$.subscribe(() => {
      this.updateView();
    });
  }

  private updateView(): void {
    if (this.currentPermissions.length === 0) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      return;
    }

    let hasPermission: boolean;

    if (this.appHasNotCustomPermissionMode === 'all') {
      hasPermission = this.permissionService.hasAllPermissions(this.currentPermissions);
    } else {
      hasPermission = this.permissionService.hasAnyPermission(this.currentPermissions);
    }

    if (!hasPermission) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }

  ngOnDestroy(): void {
    if (this.permissionSubscription) {
      this.permissionSubscription.unsubscribe();
    }
  }

}
